import * as React from "react";
import {
  ActivityFragment,
  CampaignMinimalFragment,
  MadMinimalFragment,
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { timeAgoLabel } from "../../../utils/timeAgo";
import { MadIcon } from "../../icons";
import { Link } from "../../wombat-ui";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

type MadUpdatedActivity = ActivityFragment & {
  recipient: CampaignMinimalFragment;
  trackable: MadMinimalFragment;
};

export function isMadUpdatedActivity(
  q: ActivityFragment
): q is MadUpdatedActivity {
  return q.key === "mad.updated";
}

interface MadUpdatedActivityProps {
  activity: MadUpdatedActivity;
}

export const MadUpdatedActivity: React.FC<MadUpdatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="madUpdatedActivity"
      visual={<MadIcon iconClassName="w-10 h-10 text-accent-500" />}
    >
      <Span className="text-sm">
        {t("activity.labels.madUpdated", {
          mad: (
            <Link
              to={`/mads/${activity.trackable.id}`}
              key={activity.id}
            >
              {t("activity.objects.mad")}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
